import React from 'react';

const Control = ({ children }) => <div className="control">{children}</div>;

export default Control;
